<template>
  <Modal @close="close">
    <div slot="modal-header" v-html="systemTitle"></div>

    <div class="d-flex flex-column justify-content-center align-items-center">
      <SystemView hide-back-button :system-id="system.get('modxId')" />
    </div>
    <div slot="modal-footer">
      <el-button @click="close">
        {{ $t('general.close') }}
      </el-button>
    </div>
  </Modal>
</template>

<script>
import Modal from '../atoms/Modal';
import SystemView from '../../views/systems/SystemView';
export default {
  name: 'SystemViewModal',
  components: { SystemView, Modal },
  props: {
    system: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    systemTitle() {
      return this.system.get('name');
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped></style>
